import { BaseDto } from '../../core';
import { REFUND_METHOD, REFUND_TYPE } from '../../shared';
import { Buyer } from './buyer.entity';

export class BuyerRestorationDormentDto extends BaseDto<BuyerRestorationDormentDto> {
  confirmPassword: string;
}
